import {
    SET_QUICK_QUOTE,
    SET_APPLYING_TYPE,
    SET_APPLICANTS,
    SET_MORTGAGE_TYPE,
    SET_APPLICANTS_INCOME,
    SET_ESTAMINATED_PROPERTY_VALUE,
    SET_ESTAMINATED_PROPERTY_MONTHLY_RENT,
    SET_REQUESTED_LOAN_AMOUNT,
    SET_REQUESTED_TIME_SPAN,
    GET_QUICK_QUOTE_PENDING,
    GET_QUICK_QUOTE_FULFILLED,
    SET_SAMPLE_PRODUCTS_PENDING,
    SET_SAMPLE_PRODUCTS_FULFILLED,
} from '../../../constants/ActionTypes';
import quickQuoteInitialState from './quickQuoteInitialState';

function quickQuoteReducer(state = quickQuoteInitialState, action) {
    switch (action.type) {
    case SET_QUICK_QUOTE: {
        const { data } = action;
        return {
            ...data,
            requestedLoanAmount: (
                data.requestedLoanAmount || data.remortgageAmount || data.additionalAmount
            ),
        };
    }
    case SET_APPLYING_TYPE:
        return {
            ...quickQuoteInitialState,
            applicationType: action.applicationType,
        };
    case SET_APPLICANTS: {
        return {
            ...state,
            applicants: action.applicants,
            applicantsIncome: Array(action.applicants).fill({
                amount: '',
                currency: 'gbp',
            }),
        };
    }
    case SET_MORTGAGE_TYPE:
        return {
            ...state,
            mortgageType: action.mortgageType,
        };
    case SET_APPLICANTS_INCOME: {
        const applicantsIncome = [...state.applicantsIncome];
        applicantsIncome[action.index] = {
            ...applicantsIncome[action.index],
            amount: action.event.target.value,
        };
        return {
            ...state,
            applicantsIncome,
        };
    }
    case SET_ESTAMINATED_PROPERTY_VALUE:
        return {
            ...state,
            property: {
                ...state.property,
                estaminatedPropertyValue: {
                    ...state.property.estaminatedPropertyValue,
                    amount: action.event.target.value,
                },
            },
        };
    case SET_ESTAMINATED_PROPERTY_MONTHLY_RENT:
        return {
            ...state,
            property: {
                ...state.property,
                estaminatedPropertyMonthlyRent: {
                    ...state.property.estaminatedPropertyMonthlyRent,
                    amount: action.event.target.value,
                },
            },
        };
    case SET_REQUESTED_LOAN_AMOUNT:
        return {
            ...state,
            requestedLoanAmount: {
                ...state.requestedLoanAmount,
                amount: action.event.target.value,
            },
        };
    case SET_REQUESTED_TIME_SPAN:
        return {
            ...state,
            requestedTimeSpan: action.event.target.value,
        };
    case GET_QUICK_QUOTE_PENDING:
        return {
            ...state,
            isPending: true,
            products: [],
        };
    case GET_QUICK_QUOTE_FULFILLED:
        return {
            ...state,
            isPending: false,
            products: action.payload.products,
        };
    case SET_SAMPLE_PRODUCTS_PENDING:
        return {
            ...state,
        };
    case SET_SAMPLE_PRODUCTS_FULFILLED:
        return {
            ...state,
        };
    default:
        return state;
    }
}

export default quickQuoteReducer;



// WEBPACK FOOTER //
// ./src/app/FormStepper/QuickQuote/quickQuoteReducer.js